import "./Contact.css";
import vanImg from "../assets/contact-bg.jpg";

export default function Contact() {
  return (
    <section id="contact" className="contact-section">
      <div className="contact-overlay">
        <h2>Kontakt</h2>

        {/* Adresse → Google/Apple Maps */}
        <a
          className="contact-item"
          href="https://www.google.com/maps/search/?api=1&query=Musterstraße+1,+12345+Musterstadt"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="icon">📍</span>
          Musterstraße 1, 12345 Musterstadt
        </a>

        {/* Telefon → Anruf starten */}
        <a className="contact-item" href="tel:+4915112345678">
          <span className="icon">📞</span>
          0151 12345678
        </a>

        {/* Email → Mailprogramm öffnen */}
        <a
          className="contact-item"
          href="mailto:info@af-dienstleistungen.de"
        >
          <span className="icon">✉️</span>
          info@af-dienstleistungen.de
        </a>
      </div>

      <img src={vanImg} alt="AF Dienstleistungen Fahrzeug" className="contact-bg" />
    </section>
  );
}
